/**
 * The InBrief brand lockup. Inline SVG, ported from the approved
 * demonstration so it renders identically and needs no network request.
 *
 * The wordmark uses a dotless i (U+0131) because the glyph tile already
 * supplies the dot.
 */
export function Brand({ subtitle }: { subtitle?: string }) {
  return (
    <div className="sidebar-logo">
      <div className="logo-mark">
        <span className="logo-tile">
          <svg className="logo-glyph" viewBox="0 0 220 236" role="img" aria-label="inbrief">
            <rect x="0" y="37" width="62" height="199" rx="15" fill="#12386b" />
            <rect x="79" y="0" width="62" height="236" rx="15" fill="#21b2ae" />
            <rect x="158" y="16" width="62" height="92" rx="15" fill="#cfe9e6" />
            <rect x="158" y="124" width="62" height="112" rx="15" fill="#12386b" />
          </svg>
        </span>
        <span className="logo-word">
          <span className="logo-i">&#305;</span>nbrief
        </span>
      </div>
      {subtitle ? <div className="logo-sub">{subtitle}</div> : null}
    </div>
  );
}
